module.exports = __webpack_public_path__ + "static/media/FlatBallastedImg2.65c02d22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FlatBallastedImg2.jpg
// module id = 1181
// module chunks = 0